import { configureStore } from '@reduxjs/toolkit';
import toastsReducer from './features/toastService';

export default configureStore({
  reducer: { toasts: toastsReducer },
});
